module.exports = __webpack_public_path__ + "static/media/leadpages2.4194b63c.png";